/** @jsxImportSource @emotion/react */
import { Divider } from 'ud-ui/components/divider';
import UDText from 'ud-ui/components/text';
import { Buttons, Container, defaultCSS, UDHeaderWrapper } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps {
  mainText?: string;
  subElems?: JSX.Element[];
  buttons?: JSX.Element[];
}

function UdHeaderViewBoards(props: IProps) {
  const { mainText, buttons, subElems } = props;

  return (
    <UDHeaderWrapper css={defaultCSS}>
      <Container>
        <UDText type={'subhead'} style={{ color: 'inherit', fontSize: 'inherit' }}>
          {mainText}
        </UDText>
        <Buttons>{buttons}</Buttons>
      </Container>
      <Divider type={'horizontal'} color={theme.colors.SurfacePlatinum20} />
      <Container>{subElems}</Container>
    </UDHeaderWrapper>
  );
}

export default UdHeaderViewBoards;
